export const AUTH_SWITCH_MAX_AGE_SECONDS = 10;
